// Маршруты собираются из единого описания разделов (shared/constants/routes.ts):
// там путь, страница, заголовок и роли лежат рядом, поэтому меню и гард
// маршрутов не могут разойтись.

import ProtectedLayout from '../components/auth/ProtectedLayout';
import NotFound from '../pages/NotFound';
import { buildProtectedRoutes, buildPublicRoutes } from './buildRoutes';

export const routes = [
  ...buildPublicRoutes(),
  {
    element: <ProtectedLayout />,
    children: [
      ...buildProtectedRoutes(),
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;
